import _ from 'lodash'
import useRedux from '../../utils/use_redux'
import * as actions from '../actions'

const useDomains = (path, fn) => useRedux('domains', actions, path, fn)

export default useDomains
